import { TAGSvgIcon, type IconName } from '@aspendental/shared-components-web';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { FormControlLabel, Radio, Typography, useMediaQuery, useTheme } from '@mui/material';
import { checkIconStyles, formControlLabelStyles, radioStyles } from './ReasonForVisitButton.styles';
import { DigitalVisitReasonEnum } from '@src/lib/__generated/api';
interface ReasonForVisitButtonProps {
  label: string;
  icon: IconName;
  value: DigitalVisitReasonEnum;
  selected: boolean;
}
export default function ReasonForVisitButton({
  value,
  icon,
  label,
  selected
}: Readonly<ReasonForVisitButtonProps>) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const fontVariant = isSmallScreen ? 'bodyMediumBook' : 'bodyLargeBook';
  return <FormControlLabel data-test-id={label} sx={formControlLabelStyles(selected)} control={<>
					{selected ? <CheckCircleIcon sx={checkIconStyles} data-test-id="icon_selected" /> : null}
					<Radio checkedIcon={<Icon icon={icon} />} icon={<Icon icon={icon} />} value={value} disableTouchRipple sx={radioStyles} />
				</>} label={<Typography align="center" color="secondary.main" variant={fontVariant}>
					{label}
				</Typography>} data-sentry-element="FormControlLabel" data-sentry-component="ReasonForVisitButton" data-sentry-source-file="ReasonForVisitButton.tsx" />;
}
const Icon = ({
  icon
}: {
  icon: IconName;
}) => <TAGSvgIcon icon={icon} size={40} data-sentry-element="TAGSvgIcon" data-sentry-component="Icon" data-sentry-source-file="ReasonForVisitButton.tsx" />;